import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import ListButton from 'components/button/ListButton';
import PropertiesShow from './PropertiesShow';
import Section from 'components/ui/general/Section';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { fetchProperty } from 'store/actions/properties/fetchProperties';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import fetchResourceAndLocalisationById from 'components/hoc/fetchResourceAndLocalisationById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';

class PropertiesShowContainer extends React.Component {
    render() {
        const {
            data,
            localisation,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.properties.title'),
                link: '/properties',
            },
            {
                label: data.name,
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.properties.actions.show', { title: data.name }) } />

                    <Actions>
                        <EditButton
                            url={ `/properties/${ data.id }` }
                        />

                        <ListButton url='/properties' />
                    </Actions>
                </Header>

                <Section>
                    <Column size={ 12 }>
                        <InnerColumn>
                            <PropertiesShow
                                data={ data }
                                localisation={ localisation }
                            />
                        </InnerColumn>
                    </Column>
                </Section>
            </div>
        );
    }
}

PropertiesShowContainer.propTypes = {
    data: PropTypes.object,
    localisation: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    fetchResourceAndLocalisationById({
        action: fetchProperty,
        resource: 'properties',
    })
);

export default enhance(PropertiesShowContainer);



// WEBPACK FOOTER //
// ./src/pages/properties/show/PropertiesShowContainer.js